import {keyBy, isEqual, createReducer, keys, omit, omitBy, get} from 'helpers';

export const progress = createReducer({}, {

  GOOGLE_CALENDAR_DATA_RECEIVED: (state, { syncToken, progress, select }) => {
    if (!syncToken) {
      state = {};
    }
    const stored = select('activities.storedGoogleEvents');
    const data = progress.map(item => ({
      ...item,
      activity_id: get(stored[item.activity_id], 'id') || item.activity_id,
    }));
    const updated = omit({
      ...state,
      ...keyBy(data, 'id'),
    }, keys(stored));
    return isEqual(state, updated) ? state : updated;
  },

  ACTIVITIES_STORE_GOOGLE_EVENT: (state, { googleEventId }) => {
    return omitBy(state, { activity_id: googleEventId });
  },

  GOOGLE_CALENDAR_SUCCESSFUL_CHANGE: (state, { event, select }) => {
    //check if event = progress record
    if (event && event.originalTimestamp) {
      const stored = select('activities.storedGoogleEvents');
      return {
        ...state,
        [event.id]: {
          ...event,
          // update activity_id from Google's to ours
          activity_id: get(stored[event.activity_id], 'id') || event.activity_id,
        }
      }
    }
    return state;
  },

  GOOGLE_CALENDAR_SIGNED_OUT: () => ({}),

});
